import React from 'react'
import styled from 'styled-components'
import BusSeat from './bus-seat.component'
import SteeringWheel from './../../../../assets/icons/bus/steering-wheel.component'
import { LIGHTGRAY, LIGHTERGRAY } from '../../../styles/colors.style'
import { seatDomId } from '../../../helpers/seat-key.helper'

const busWidth = '250px'
const borderWidth = '1px'
const busPrimaryColor = '#e3e3e3'
const StyledBus = styled.div`
	background: ${busPrimaryColor};
	border: ${borderWidth} solid ${busPrimaryColor};
	border-bottom-left-radius: 2.1em 2.1em;
	border-bottom-right-radius: 2.1em 2.1em;
	border-top-left-radius: 6em 2em;
	border-top-right-radius: 6em 2em;
	box-sizing: border-box;
	overflow: hidden;
	position: relative;
	width: ${busWidth};
	margin: 0 auto;

	&:before,
	&:after {
		background: ${LIGHTGRAY};
		content: '';
		height: 3em;
		position: absolute;
		top: -1.5em;
		width: 3em;
	}

	&:before {
		border-bottom-left-radius: 1em 1em;
		border-bottom-right-radius: 2em 2em;
		left: -0.5em;
	}

	&:after {
		border-bottom-left-radius: 2em 2em;
		border-bottom-right-radius: 1em 1em;
		right: -0.5em;
	}
`

const busSeatsOffset = '16px'
const busFrontalWidth = '20px'
const StyledBusInner = styled.div`
	background: white;
	border-bottom-left-radius: 2.1em 2.1em;
	border-bottom-right-radius: 2.1em 2.1em;
	border-top: 0.7em solid ${LIGHTERGRAY};
	border-top-left-radius: 6em 2em;
	border-top-right-radius: 6em 2em;
	box-sizing: border-box;
	position: relative;
	top: ${busFrontalWidth};
	width: calc(${busWidth} - 2 * ${borderWidth});

	.steering-wheel {
		margin-left: ${busSeatsOffset};
		margin-top: 5em;
	}
`

const busSeatsWidth = `calc(${busWidth} - 2 * ${borderWidth} - 2 * ${busSeatsOffset})`
const busBottomOffset = 0.5
const busSeatVerticalSpacing = '8px'
const busSeatsHeight = `calc(${busSeatVerticalSpacing} + ${busSeatsWidth} / 5)`

const StyledBusSeats = styled.div`
	height: calc(${busSeatsHeight} * ${({ maxX }) => ~~maxX + busBottomOffset});
	margin-bottom: 1.5em;
	margin-left: ${busSeatsOffset};
	margin-top: 1em;
	position: relative;
	width: calc(100% - 2 * ${busSeatsOffset});
`

const Bus = ({ busSeats, totalSeats, onSelect, onDeselect }) => {
	const maxX = Math.max.apply(
		null,
		busSeats.map(({ x }) => x)
	)

	return (
		<StyledBus>
			<StyledBusInner>
				<SteeringWheel
					size={40}
					color={LIGHTGRAY}
					className="steering-wheel"
				/>
				<StyledBusSeats maxX={maxX}>
					{busSeats.map((seat, index) => (
						<BusSeat
							x={seat.x}
							y={seat.y}
							key={seatDomId(seat) || index}
							domId={seatDomId(seat)}
							discount={seat.discount}
							available={seat.available}
							busSeatNumber={seat.number}
							busSeatsWidth={busSeatsWidth}
							onClick={() => {
								// Spec 055: passa a poltrona inteira — só o número não diz o andar.
								return seat.available
									? onSelect(seat, seat.discount)
									: onDeselect(seat)
							}}
							busSeatVerticalSpacing={busSeatVerticalSpacing}
						/>
					))}
				</StyledBusSeats>
			</StyledBusInner>
		</StyledBus>
	)
}

export default Bus
